export default {"src":"https://s.sylndr.com/c-c51c782/_next/static/media/kMIconGreen.32869f0c.svg","height":18,"width":22,"blurWidth":0,"blurHeight":0};